import { api } from 'services/api';

const officialDocumentService = api.injectEndpoints({
  endpoints: (builder) => ({
    officialDocuments: builder.query<ResultModel<OfficialDocument[]>, void>({
      query: () => ({
        url: `/5B3464B83CD17502A2876A25BC6E3399/List`,
        method: 'POST',
        body: {
          isActive: true,
        },
      }),
    }),
    officialDocumentForPatient: builder.query<
      ResultModel<OfficialDocument>,
      OfficialDocumentRequestForPatient
    >({
      query: (body) => ({
        url: `/5B3464B83CD17502A2876A25BC6E3399/FilterForPatient`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    basketDocuments: builder.query<ResultModel<BasketDocumentsResponse[]>, BasketDocumentsRequest>({
      query: (body) => ({
        url: `/5B3464B83CD17502A2876A25BC6E3399/basket-documents.json`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    basketDocumentResource: builder.query<
      ResultModel<BasketDocumentResourceResponse>,
      BasketDocumentResourceRequest
    >({
      query: (body) => ({
        url: `/5B3464B83CD17502A2876A25BC6E3399/basket-document-resource.json`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    categoryDocuments: builder.query<
      ResultModel<CategoryDocumentsResponse[]>,
      CategoryDocumentsRequest
    >({
      query: (body) => ({
        url: `/5B3464B83CD17502A2876A25BC6E3399/category-documents.json`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
  }),
});

export const {
  useOfficialDocumentsQuery,
  useOfficialDocumentForPatientQuery,
  useBasketDocumentsQuery,
  useBasketDocumentResourceQuery,
  useCategoryDocumentsQuery,
} = officialDocumentService;

